module.exports = __webpack_public_path__ + "static/5-4c0e83fe7bf54e57ce515ce013895343.png";